var SearchCTA = (function () {
  

  var $context = $('.acr-search-cta');

  function init() {
    checkInitialValue();
    attachEvents();
  }

  function checkInitialValue() {
    $('input', $context).each(function (i, el) {
      var $inputElem = $(el);
      if ($inputElem.val().length > 0) {
        $inputElem.addClass('acr-not-empty');
        $inputElem.parents('.acr-search-cta').addClass('active');
      }
    });
  }

  function attachEvents() {
    $('input', $context)
      .on('focus', function () {
        setActive(this);
      });


    $('input', $context)
      .on('blur', function () {
        setActive(this);
      });

    // Don't submit if form is empty.
    $('button[type="submit"]', $context)
      .on('click', function (e) {
        var $matchingInput = $(e.currentTarget).parent().find('input[id="cta-search-term"]');
        if ($matchingInput.val().length === 0) {
          e.preventDefault();
        }
      });
  }

  function setActive(elem) {
    var $parentContext = $(elem).parents('.acr-search-cta');
    if ($(elem).hasClass('acr-not-empty')) {
      $parentContext.addClass('active');
    } else {
      $parentContext.removeClass('active');
    }
  }

  return {
    init: init,
  };
}());
